<template>
  <div class="w-full max-w-5xl mx-auto text-center mt-20">
    <div class="my-8 grid grid-cols-1 sm:grid-cols-2 text-left gap-x-10 text-lg px-7">
      <!-- other bootcamps -->
      <div class="my-10">
        <h3 class="text-2xl font-semibold mb-10">Other Courses</h3>
        <div class="flex flex-col gap-y-5">
          <ProOrCon :isPro=false>
            <p>Teach Lambda, API Gateway, DynamoDB, EventBridge, Step Functions as separate services.</p>
          </ProOrCon>
          <ProOrCon :isPro=false>
            <p>Focus on building and deploying.</p>
          </ProOrCon>
          <ProOrCon :isPro=false>
            <p>Give examples that work in demos.</p>
          </ProOrCon>
          <ProOrCon :isPro=false>
            <p>Leave you to adapt patterns alone.</p>
          </ProOrCon>
        </div>
      </div>

      <!-- this bootcamp -->
      <div class="my-10">
        <h3 class="text-2xl font-semibold mb-10">Production-Ready Serverless</h3>
        <div class="flex flex-col gap-y-5">
          <ProOrCon :isPro=true>
            <p>Shows how these services fit together in production systems.</p>
          </ProOrCon>
          <ProOrCon :isPro=true>
            <p>Covers testing, CI/CD, security, observability, cost control, and failure handling.</p>
          </ProOrCon>
          <ProOrCon :isPro=true>
            <p>Teaches trade-offs and failure modes from real production experience.</p>
          </ProOrCon>
          <ProOrCon :isPro=true>
            <p>Gives you live Q&A and direct support.</p>
          </ProOrCon>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProOrCon from '@/components/comparison/ProOrCon.vue'

export default {
  components: {
    ProOrCon
  }
}
</script>
